// Copyright (c) 2026 Nathan Blackman / Find My Trout. All rights reserved.

import React from 'react';
import { Home, Map, Heart, Users, MessageCircle } from 'lucide-react';

const TopNav = ({ currentPage, setCurrentPage, user, userProfile }) => {
  const getUserInitials = () => {
    if (!user || !user.displayName) return '?';
    return user.displayName
      .split(' ')
      .map(n => n[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  const photoURL = userProfile?.photoURL || user?.photoURL;

  return (
    <>
      <nav className="top-nav">
        <div className="nav-container">
          <a href="#" className="logo" onClick={(e) => { e.preventDefault(); setCurrentPage('home'); }}>
            <div className="logo-icon">
              <img src="/Find_My_Trout_Logo.png" alt="Find My Trout" />
            </div>
            <span className="logo-text">
              Find My <span className="trout">Trout</span>
            </span>
          </a>

          <ul className="nav-menu">
            <li
              className={`nav-item ${currentPage === 'home' ? 'active' : ''}`}
              onClick={() => setCurrentPage('home')}
            >
              <Home size={18} />
              Home
            </li>
            <li
              className={`nav-item ${currentPage === 'map' ? 'active' : ''}`}
              onClick={() => setCurrentPage('map')}
            >
              <Map size={18} />
              Map
            </li>
            <li
              className={`nav-item ${currentPage === 'favorites' ? 'active' : ''}`}
              onClick={() => setCurrentPage('favorites')}
            >
              <Heart size={18} />
              Favorites
            </li>
            <li
              className={`nav-item ${currentPage === 'community' ? 'active' : ''}`}
              onClick={() => setCurrentPage('community')}
            >
              <Users size={18} />
              Community
            </li>
            <li
              className={`nav-item ${currentPage === 'chat' ? 'active' : ''}`}
              onClick={() => setCurrentPage('chat')}
            >
              <MessageCircle size={18} />
              Messages
            </li>
          </ul>

          {user ? (
            <div className="user-badge user-badge-desktop" onClick={() => setCurrentPage('profile')}>
              <div className="user-avatar">
                {photoURL ? (
                  <img src={photoURL} alt="" className="user-avatar-img" />
                ) : (
                  getUserInitials()
                )}
              </div>
              <span>{user.displayName?.split(' ')[0] || 'User'}</span>
            </div>
          ) : (
            <button
              type="button"
              className="user-badge user-badge-desktop nav-sign-in"
              onClick={() => setCurrentPage('auth')}
            >
              Sign in
            </button>
          )}
        </div>
      </nav>

      <nav className="bottom-nav" aria-label="Mobile navigation">
        <button
          type="button"
          className={`bottom-nav-item ${currentPage === 'home' ? 'active' : ''}`}
          onClick={() => setCurrentPage('home')}
          aria-current={currentPage === 'home' ? 'page' : undefined}
        >
          <Home size={22} aria-hidden />
          <span>Home</span>
        </button>
        <button
          type="button"
          className={`bottom-nav-item ${currentPage === 'map' ? 'active' : ''}`}
          onClick={() => setCurrentPage('map')}
          aria-current={currentPage === 'map' ? 'page' : undefined}
        >
          <Map size={22} aria-hidden />
          <span>Map</span>
        </button>
        <button
          type="button"
          className={`bottom-nav-item ${currentPage === 'favorites' ? 'active' : ''}`}
          onClick={() => setCurrentPage('favorites')}
          aria-current={currentPage === 'favorites' ? 'page' : undefined}
        >
          <Heart size={22} aria-hidden />
          <span>Favorites</span>
        </button>
        <button
          type="button"
          className={`bottom-nav-item ${currentPage === 'community' ? 'active' : ''}`}
          onClick={() => setCurrentPage('community')}
          aria-current={currentPage === 'community' ? 'page' : undefined}
        >
          <Users size={22} aria-hidden />
          <span>Community</span>
        </button>
        <button
          type="button"
          className={`bottom-nav-item ${currentPage === 'chat' ? 'active' : ''}`}
          onClick={() => setCurrentPage('chat')}
          aria-current={currentPage === 'chat' ? 'page' : undefined}
        >
          <MessageCircle size={22} aria-hidden />
          <span>Messages</span>
        </button>
        <button
          type="button"
          className={`bottom-nav-item ${currentPage === 'profile' ? 'active' : ''}`}
          onClick={() => (user ? setCurrentPage('profile') : setCurrentPage('auth'))}
          aria-current={currentPage === 'profile' ? 'page' : undefined}
        >
          <div className="bottom-nav-avatar">
            {user && photoURL ? (
              <img src={photoURL} alt="" />
            ) : (
              <span className="bottom-nav-initials">{getUserInitials()}</span>
            )}
          </div>
          <span>{user ? 'Profile' : 'Sign in'}</span>
        </button>
      </nav>
    </>
  );
};

export default TopNav;
